import { styled } from "@mui/material/styles"

// eslint-disable-next-line import/prefer-default-export
export const StyledVideo = styled("video")(() => ({
  display: "block",
  objectFit: "fill",
  width: "100%"
}))
